import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/lib/theme";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ContentProvider } from "@/lib/content";

import HomePage from "@/pages/HomePage";
import LegalPage from "@/pages/LegalPage";
import ReviewsPage from "@/pages/ReviewsPage";
import PaymentPage from "@/pages/PaymentPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentFailurePage from "@/pages/PaymentFailurePage";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminContent from "@/pages/admin/AdminContent";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminLicense from "@/pages/admin/AdminLicense";
import AdminPayments from "@/pages/admin/AdminPayments";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <ContentProvider>
            <BrowserRouter>
              <Toaster richColors position="top-right" />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/payment" element={<PaymentPage />} />
                <Route path="/payment/success" element={<PaymentSuccessPage />} />
                <Route path="/payment/failure" element={<PaymentFailurePage />} />
                <Route path="/privacy" element={<LegalPage docKey="privacy" />} />
                <Route path="/terms" element={<LegalPage docKey="terms" />} />
                <Route path="/refund" element={<LegalPage docKey="refund" />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="content" element={<AdminContent />} />
                  <Route path="team" element={<AdminTeam />} />
                  <Route path="reviews" element={<AdminReviews />} />
                  <Route path="payments" element={<AdminPayments />} />
                  <Route path="license" element={<AdminLicense />} />
                </Route>
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </ContentProvider>
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
